import { fabric } from 'fabric';
import Vec2 from 'vec2';

import { BATWING_ANGLE, SELECTION_CIRCLE_OPACITY } from '~/core/constants';
import { CornerInfo } from '~/core/models';
import theme from '~/theme/theme';

const {
  drawingTool: { secondaryBorderColor },
} = theme.light;

export const getClipCircle = (
  outlinePt: CornerInfo,
  useOverlay: boolean,
  radius?: number
) => {
  const angleOffset2 = outlinePt.angle === BATWING_ANGLE ? 45 : 0;
  const clipCircle = new fabric.Circle({
    radius,
    left: (outlinePt.radiusCenterPoint as Vec2).x,
    top: (outlinePt.radiusCenterPoint as Vec2).y,
    originX: 'center',
    originY: 'center',
    startAngle: (outlinePt.orientationAngle as number) + angleOffset2,
    endAngle: (outlinePt.orientationAngle as number) + 90, // ...why this doesn't include angleOffset2
  });

  if (useOverlay) {
    clipCircle.set({
      fill: secondaryBorderColor,
      opacity: SELECTION_CIRCLE_OPACITY,
    });
  }

  return clipCircle;
};
